import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20 19l-8 -5.5l-8 5.5","key":"svg-0"}],["path",{"d":"M12 4v9.5","key":"svg-1"}],["path",{"d":"M12 4m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-2"}],["path",{"d":"M4 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-3"}],["path",{"d":"M20 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-4"}]]

const IconGizmo = createReactComponent('outline', 'gizmo', 'Gizmo', __iconNode);

export default IconGizmo;